module.exports = __webpack_public_path__ + "img/ituverava.18e8e243.png";